<template>
  <v-slide-x-reverse-transition>
    <v-card class="elevation-5 condition-details vop-bg-whisper" v-show="isVisible">
      <div>
        <!-- Header title -->
        <v-toolbar flat color="vop-bg-whisper">
          <v-toolbar-title class="subheading ttu font-weight-medium">
            <span>{{ messages.label.ADD_RULESETS }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="hide()">
            <v-icon medium>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- Rulesets search filter -->
          <v-layout row wrap>
            <!-- Ruleset State -->
            <v-flex md2 sm2>
              <v-select v-model="selectedRuleState" :label="messages.label.RULE_STATE" :items="ruleStateList"
                item-text="text" item-value="value" return-object></v-select>
            </v-flex>
            <!-- Ruleset Title -->
            <v-flex md3 sm3>
              <v-text-field :label="messages.label.RULE_TITLE" v-model="ruleTitle" clearable></v-text-field>
            </v-flex>
            <!-- Search Button -->
            <v-flex md2 sm2>
              <v-btn color="primary" @click="searchRuleSets()">
                {{
                    messages.label.SEARCH
                }}
              </v-btn>
            </v-flex>
          </v-layout>
          <!-- Rule sets serach result -->
          <v-layout row wrap>
            <v-flex>
              <v-data-table :headers="ruleSetHeaders" v-model="selectedRuleSets" :items="ruleSetsList"
                :pagination.sync="pagination" :total-items="totalItems" :loading="ruleSetsLoading"
                :rows-per-page-items="rowsPerPagesArray">
                <!-- Items -->
                <template slot="items" slot-scope="props">
                  <tr>
                    <td>
                      <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                    </td>
                    <td class="text-xs-left">{{ props.item.title }}</td>
                    <td class="text-xs-left">{{ getRulesCount(props.item.items) }}</td>
                    <td class="text-xs-left">{{ props.item._enabled }}</td>
                    <td @click.stop="stopProp" class="justify-center layout px-0">
                      <!-- View Details icon -->
                      <v-tooltip bottom slot="activator">
                        <template v-slot:activator="{ on }">
                          <v-icon small v-on="on" @click="showRuleSetQuickView(props.item)">open_in_new</v-icon>
                        </template>
                        <span>View Details</span>
                      </v-tooltip>
                      <!-- Mode Menu -->
                      <v-menu bottom left :disabled="ruleSetsLoading">
                        <v-tooltip bottom slot="activator">
                          <template v-slot:activator="{ on }">
                            <v-btn icon medium v-on="on" class="grey--text text--darken-2">
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <span>More</span>
                        </v-tooltip>
                        <v-list>
                          <v-list-tile>
                            <v-list-tile-title>
                              {{
                                  messages.label.TEST
                              }}
                            </v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile @click="goToEditView(props.item)">
                            <v-list-tile-title>
                              {{
                                  messages.label.EDIT
                              }}
                            </v-list-tile-title>
                            <v-icon small right>exit_to_app</v-icon>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </template>
                <!-- No Data -->
                <template slot="no-data">
                  <v-alert :value="true" color="info" class="black--text" icon="info">
                    <span v-if="!initiatedSearch">{{ messages.info.SELECT_SEARCH_CRITERIA }}</span>
                    <span v-else>{{ messages.info.NO_SEARCH_RESULTS }}</span>
                  </v-alert>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- Snackbar -->
          <v-flex xs12>
            <v-snackbar :bottom="true" :timeout="snackbar.timeout" :color="snackbar.color" v-model="snackbar.show">
              {{ snackbar.message }}
              <v-btn flat color="secondary" @click.native="snackbar.show = false">{{ messages.label.OK }}</v-btn>
            </v-snackbar>
          </v-flex>
        </v-card-text>
      </div>
      <!-- Dialogs -->
      <v-dialog v-model="ruleSetQuickView" width="1000" height="800">
        <RuleSetQuickView />
      </v-dialog>
      <!-- Actions -->
      <v-card-actions class="px-3">
        <v-spacer />
        <v-btn color="primary" class="ml-2" :disabled="selectedRuleSets.length === 0"
          @click="updateRuleSetsInRuleCollection">{{ messages.label.ADD_SELECTED }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-slide-x-reverse-transition>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex"
import messages from "@/XVAT/messages.json"
import XVATRulesService from "@/XVAT/XVATRulesService"
import * as xvatDataService from "@/XVAT/XVATDataService"
import RuleSetQuickView from "@/XVAT/RuleSet/RuleSetQuickView"
import {
  RULE_COLLECTION_HAS_RULES_SETS
} from "@/store/constants/getter-types"
import { SET_RULECOLLECTION_RULESETS } from "@/store/constants/mutation-types"

export default {
  name: "AddRuleSets",
  components: {
    RuleSetQuickView
  },
  computed: {
    ...mapState("xvat", ["ruleCollectionRuleSetsList", "addRuleSetsFilters"]),
    ...mapGetters("xvat", [ RULE_COLLECTION_HAS_RULES_SETS ])
  },
  watch: {
    /**
     * Watch handler for pagination object
     */
    pagination: {
      handler(newVal, oldVal) {
        if (this.initiatedSearch && oldVal !== newVal) {
          this.searchRuleSets()
        }
      },
      deep: true
    }
  },
  data() {
    return {
      isVisible: true,
      ruleStateList: this.getRuleStates(),
      initiatedSearch: false,
      selectedRuleState: { text: "All", value: "all" },
      ruleTitle: "",
      ruleSetHeaders: this.getSetRuleHeaders(),
      ruleSetsList: [],
      selectedRuleSets: [],
      pagination: {
        sortBy: "title",
        page: 1,
        rowsPerPage: 10,
        descending: false
      },
      snackbar: {
        show: false,
        timeout: 5000,
        message: "",
        color: "error"
      },
      totalItems: 0,
      ruleSetsLoading: false,
      rowsPerPagesArray: [10, 25],
      ruleSetQuickView: false
    }
  },
  methods: {
    ...mapMutations("xvat", [SET_RULECOLLECTION_RULESETS]),
    /**
     * getSetRuleHeaders - get headers array
     * @returns {array}
     */
    getSetRuleHeaders() {
      return [
        {
          text: "",
          sortable: false
        },
        {
          text: messages.label.TH_TITLE,
          align: "left",
          sortable: false,
          value: "title"
        },
        {
          text: messages.label.TH_RULES_COUNT,
          sortable: false,
          align: "left",
          value: "conditions"
        },
        {
          text: messages.label.TH_ENABLED,
          sortable: false,
          align: "left",
          value: "_enabled"
        },
        {
          text: "",
          sortable: false
        }
      ]
    },

    /**
     * stopProp - Do nothing, just to stop event propogation
     */
    stopProp() { },

    /**
     * Hide side sheet view
     */
    hide() {
      this.isVisible = false
      this.resetData()
      XVATRulesService.$emit("event:hideAddRuleSetsSheet")
    },

    /**
     * Show add rules sheet view
     */
    show() {
      this.isVisible = true
    },

    /**
     * resetData
     */
    resetData() {
      this.selectedRuleSets = []
      this.ruleSetsList = []
      this.initiatedSearch = false
      this.selectedRuleState = { text: "All", value: "all" }
      this.ruleTitle = ""
      this.totalItems = 0
    },

    /**
     * Get pagination params
     */
    getPageParams(pagination) {
      let startRange
      let endRange
      if (pagination.page === 1) {
        startRange = 1
        endRange = pagination.rowsPerPage
      } else {
        startRange = (pagination.page - 1) * pagination.rowsPerPage + 1
        endRange = startRange + pagination.rowsPerPage - 1
      }
      return startRange + "-" + endRange
    },

    /**
     * getSortParams - Construct sorting param
     *
     * @param  {object} pagination pagination object
     * @return {string}            ex: "<filedName>|desc"
     */
    getSortParams(pagination) {
      let sortParams = ""
      sortParams =
        !this.$lodash.isNull(pagination.sortBy) &&
          !this.$lodash.isEmpty(pagination.sortBy)
          ? pagination.sortBy
          : "title"
      if (pagination.descending) {
        sortParams += "|desc"
      }
      return sortParams
    },

    /**
     * getRuleStates
     * @returns {array}
     */
    getRuleStates() {
      return [
        { text: "All", value: "all" },
        { text: "Enabled", value: "enabled" },
        { text: "Disabled", value: "disabled" }
      ]
    },

    /**
     *  getRulesCount - return count of rules exists in a rule set or in a rule collections
     * @param {array} itemsArray
     */
    getRulesCount(itemsArray) {
      if (!this.$lodash.isUndefined(itemsArray)) {
        return itemsArray.length
      } else {
        return 0
      }
    },

    /**
     * searchRules - trigger the search event for retrieving all the rules, rule sets and rule collection
     */
    searchRuleSets() {
      this.ruleSetsLoading = true
      let queryObject = {}

      // Disabled query
      if (this.selectedRuleState.value === "enabled") {
        queryObject.byDisabled = false
      } else if (this.selectedRuleState.value === "disabled") {
        queryObject.byDisabled = true
      }

      // Title Query
      if (this.ruleTitle !== "") {
        queryObject.byTitlePrefix = this.ruleTitle
      } else {
        queryObject.byTitlePrefix = ""
      }

      // TYPE
      if (
        !this.$lodash.isUndefined(this.addRuleSetsFilters.ruleCollectionType)
      ) {
        queryObject.byType = this.addRuleSetsFilters.ruleCollectionType
      }

      // Omit "grouping" as it's client only
      queryObject.range = this.getPageParams(this.pagination)
      queryObject.sort = this.getSortParams(this.pagination)

      return xvatDataService
        .searchRuleSet(queryObject)
        .then(response => {
          this.ruleSetsList = XVATRulesService.addClientOnlyFields(
            response.data.entries
          )
          this.totalItems = response.data.entryCount
          return response
        })
        .catch(error => {
          // TODO: handle error
          this.rulesList = []
          this.totalItems = 0
          return Promise.reject(error)
        })
        .finally(() => {
          this.ruleSetsLoading = false
          this.initiatedSearch = true
        })
    },

    /**
     * updateRuleSetsInRuleCollection - update rule selection for ruleset
     */
    updateRuleSetsInRuleCollection() {
      let ruleCollectionRuleSetsToUpdate = []
      this.ruleSetsLoading = false // not required due to above todo
      if (this.RULE_COLLECTION_HAS_RULES_SETS) {
        // Already have some rule sets, so update
        ruleCollectionRuleSetsToUpdate = this.$lodash.cloneDeep(
          this.ruleCollectionRuleSetsList
        )
        this.$lodash.forEach(this.selectedRuleSets, value => {
          let isInListIndex = this.$lodash.findIndex(
            ruleCollectionRuleSetsToUpdate,
            ["id", value.id]
          )
          if (isInListIndex === -1) {
            ruleCollectionRuleSetsToUpdate.push(value)
          }
        })
        this.SET_RULECOLLECTION_RULESETS(ruleCollectionRuleSetsToUpdate)
      } else {
        this.$lodash.forEach(this.selectedRuleSets, (/* value */) => {
          this.SET_RULECOLLECTION_RULESETS(this.selectedRuleSets)
        })
      }
      this.hide()
      XVATRulesService.$emit("event:validateForUpdateRuleCollection")
    },

    /**
     * goToEditView - Navigate to Edit view
     * @param {object} ruleSet
     */
    goToEditView(ruleSet) {
      let id = ruleSet.id
      let location = "/xvat/rule-set/" + id
      window.open(location, "_blank")
    },

    /**
     * showRuleSetQuickView - Show rule quick view in dialog
     */
    showRuleSetQuickView(rule) {
      this.ruleSetQuickView = true
      XVATRulesService.$emit("event:showRuleSetQuickViewDialog", rule)
    },

    /**
     * Hide quick view dialog
     */
    hideRuleSetQuickView() {
      this.ruleSetQuickView = false
    },

    /**
     * updateSearchResults - Update serach results if some results exist
     */
    updateSearchResults() {
      if (this.ruleSetsList.length > 0) {
        if (this.pagination.page > 1) {
          this.pagination.page = 1 // Triggers search
        }
        this.searchRuleSets()
      }
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Initial data
     */
    /**
     * Events
     */
    XVATRulesService.$on("event:showAddRuleSetsSheet", this.show)
    XVATRulesService.$on("event:ruleCollectionDataRetrieved", this.hide)
    XVATRulesService.$on(
      "event:hideRuleSetQuickViewDialog",
      this.hideRuleSetQuickView
    )
    XVATRulesService.$on(
      "event:addRuleSetsFilterUpdated",
      this.updateSearchResults
    )
  },
  beforeDestroy() {
    XVATRulesService.$off("event:showAddRuleSetsSheet", this.show)
    XVATRulesService.$off("event:ruleCollectionDataRetrieved", this.hide)
    XVATRulesService.$off(
      "event:hideRuleSetQuickViewDialog",
      this.hideRuleSetQuickView
    )
    XVATRulesService.$off(
      "event:addRuleSetsFilterUpdated",
      this.updateSearchResults
    )
  }
}
</script>

<style lang="scss">
.condition-details {
  min-height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/XVAT/RuleCollection/AddRuleSets.vue